import React, { Component } from "react";
import { Spin } from "antd";
import { notification, message } from 'antd';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default class PersUnidadMed extends Component{

  state = {
    personal:[],
    loading: false
  }
  
  componentDidMount() {
    
      const { unidad_medica_user, periodo, backend } = this.props;

      fetch(`${backend}/personalunidadmedica/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
      }).then((data) => {
          this.setState({
            personal: data.data,
            loading:true
          })
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener información del personal de la unidad médica.",
          });
          message.destroy()
      });

    // }, 3000);
  }

  render(){

    const { personal, loading } = this.state;

    return(
      loading ? 
        <TableContainer component={Paper}>
          <Table 
          sx={{ 
            // minWidth: 700 
            // maxWidth:700
          }} 
          size="small" aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Tipo de personal</StyledTableCell>
                <StyledTableCell align="center">No. de personal</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {personal.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell component="th" scope="row">
                    {row.name}
                  </StyledTableCell>
                  <StyledTableCell align="center">{row.value}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        : <Spin size="small" />
    );
  }
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor:'rgb(36, 98, 151)',
    color: theme.palette.common.white,
    fontWeight:'bold',
    fontSize:17
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));